import styles from './catalog-picker-modal.module.css'

import { RxPlus } from '@react-icons/all-files/rx/RxPlus'
import React, { useState } from 'react'

import { Button, Flex, Popover, Text, TextField } from 'components/ds'

type SelectionBarProps = {
  count: number
  onClear: () => void
  onSaveAsGroup: (name: string) => void
}

/**
 * Sits above the catalog list while catalogs are ticked: shows the count, a
 * quick Clear, and saves the selection as a named group without leaving the
 * list.
 */
export const SelectionBar = ({
  count,
  onClear,
  onSaveAsGroup,
}: SelectionBarProps) => {
  const [isNaming, setIsNaming] = useState(false)
  const [name, setName] = useState('')

  const handleOpenChange = (open: boolean) => {
    setIsNaming(open)
    if (open) setName('')
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!name.trim()) return
    onSaveAsGroup(name.trim())
    setIsNaming(false)
  }

  return (
    <Flex align="center" justify="between" className={styles.selectionBar}>
      <Flex align="center" gap="2">
        <Text size="2" weight="medium">
          {count} selected
        </Text>
        <Text size="2" color="gray" aria-hidden="true">
          ·
        </Text>
        <Button variant="ghost" color="gray" size="1" onClick={onClear}>
          Clear
        </Button>
      </Flex>

      <Popover.Root open={isNaming} onOpenChange={handleOpenChange}>
        <Popover.Trigger>
          <Button variant="ghost" size="1">
            <RxPlus /> Save as group
          </Button>
        </Popover.Trigger>
        <Popover.Content
          align="end"
          width="280px"
          className={styles.namingPopover}
        >
          <form onSubmit={handleSubmit}>
            <Flex direction="column" gap="3">
              <Flex direction="column" gap="1">
                <Text
                  as="label"
                  size="2"
                  weight="medium"
                  htmlFor="selection-group-name"
                >
                  Group name
                </Text>
                <TextField.Root
                  id="selection-group-name"
                  placeholder="e.g. Indie labels"
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
                <Text size="1" color="gray">
                  {`${count} ${count === 1 ? 'catalog' : 'catalogs'}`}
                </Text>
              </Flex>
              <Flex justify="end" gap="2">
                <Popover.Close>
                  <Button type="button" variant="soft" color="gray" size="1">
                    Cancel
                  </Button>
                </Popover.Close>
                <Button type="submit" size="1" disabled={!name.trim()}>
                  Save group
                </Button>
              </Flex>
            </Flex>
          </form>
        </Popover.Content>
      </Popover.Root>
    </Flex>
  )
}
